import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot, CanMatch,
  CanMatchFn, GuardResult, MaybeAsync, Route,
  Router,
  RouterStateSnapshot, UrlSegment,
  UrlTree
} from '@angular/router';
import { Observable } from "rxjs";
import { ABP, ConfigStateService } from '@abp/ng.core';
import { eThemeSharedRouteNames } from '@abp/ng.theme.shared';

@Injectable({
  providedIn: "root",
})
export class TenantGuard implements CanMatch {
  constructor(
    private router: Router,
    private config: ConfigStateService,
  ) {}
  canMatch(route: Route, segments: UrlSegment[]): MaybeAsync<GuardResult> {
    const currentUser = this.config.getOne("currentUser");
    if (currentUser) {
      const hasAdministrationRole = currentUser.roles?.includes('Admin Cargo Fleet');
      const isInHostTenant = currentUser.tenantId == null;

      return hasAdministrationRole && isInHostTenant;
    }

    return false; 
  }
}

@Injectable({
  providedIn: "root",
})
export class TenantGuardHost implements CanMatch {
  constructor(
    private router: Router,
    private config: ConfigStateService,
  ) {}
  canMatch(route: Route, segments: UrlSegment[]): MaybeAsync<GuardResult> {
    const currentUser = this.config.getOne("currentUser");
    if (currentUser) {

      const hasAdministrationRole = currentUser.roles?.includes('admin');
      const isInHostTenant = currentUser.tenantId == null;

      return hasAdministrationRole && isInHostTenant;
    }
  }
}


